import {UserAccount, UserAccounts} from "./types";

export const OAuthStore = {
  setSession(sessionId: string): void {
    sessionStorage.setItem("oauth-session-id", sessionId);
  },
  getSession(): string | null {
    return sessionStorage.getItem("oauth-session-id");
  },
  clear: (): void => {
    sessionStorage.removeItem("oauth-session-id");
    sessionStorage.removeItem("oauth-redirect-uri");
  },
  setRedirectUri(redirectUri: string): void {
    sessionStorage.setItem("oauth-redirect-uri", redirectUri);
  },
  getRedirectUri(): string {
    return sessionStorage.getItem("oauth-redirect-uri") || "";
  }
}

export const UserAccountStore = {
  clear() {
    localStorage.removeItem("accounts");
  },
  get(): UserAccounts {
    const accounts = localStorage.getItem("accounts");
    if (!accounts) {
      return new UserAccounts([]);
    }
    const userAccounts: UserAccount[] = JSON.parse(accounts);
    return new UserAccounts(userAccounts);
  },
  set(userAccounts: UserAccounts) {
    const accounts = userAccounts.list();
    localStorage.setItem("accounts", JSON.stringify(accounts));
    return
  },
}

